// extracted by mini-css-extract-plugin
export default {"crLoadingOverlay":"CrLoadingOverlay_crLoadingOverlay__xBT4s","opaque":"CrLoadingOverlay_opaque__8PCc2"};